<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="10000" />

    <div v-if="loading" class="topRemark">
      <template v-if="data.state==='WAIT'">
        您的认证信息已保存， <b :style="'color: '+GetColorMain()">{{ data.proUseName }}</b>教练提醒您<b :style="'color: '+GetColorMain()">再次核对信息</b>是否准确，确认无误请点击底部按钮“提交给教练”。
      </template>
      <template v-if="data.state==='FINISH'">
        您的证书已经签发，恭喜您。
      </template>
      <template v-else>
        您的认证信息已提交，请耐心等待 <b :style="'color: '+GetColorMain()">{{ data.proUseName }}</b>教练为您处理，如需帮助请联系<b :style="'color: '+GetColorMain()">{{ data.proUseName }}</b>教练。
      </template>
    </div>
    <div v-if="loading && data.state==='FINISH'" class="fastRect">
      <div class="title">认证结果</div>
      <img :src="GetServiceUrl()+'image/getPadiTemplateCard?id='+data.picId+'&time='+data.cardTime+'&sign=' +data.cardSign" style="width:100%;">
    </div>
    <div v-if="loading" class="fastRect">
      <div class="title">认证信息</div>
      <van-field
        v-model="data.picId"
        readonly
        label="认证号"
      />
      <div v-if="data.state!=='WAIT'" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>状态</span></div>
        <div :style="'color: '+GetColorMain()">
          <b>{{ state }}</b>
        </div>
      </div>
      <van-field
        v-model="data.groupTeam"
        readonly
        label="机构"
      />
      <van-field
        v-model="data.picTypeName"
        readonly
        label="类型"
      />
      <van-field
        v-model="data.picCourse"
        readonly
        label="证书"
        placeholder="请选择证书"
      />
      <van-field
        v-model="createTime"
        readonly
        label="创建时间"
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>认证日期</span></div>
        <div>
          {{ formatDate(data.certificationDate,"yyyy/MM/dd") }}
        </div>
      </div>
      <template v-if="data.state==='WAITCONFIRM' && data.userConfirmTime">
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>申请时间</span></div>
          <div>
            {{ formatDate(data.userConfirmTime,"yyyy/MM/dd hh:mm",true) }}
          </div>
        </div>
      </template>
      <template v-if="data.verifyProTime">
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>审核时间</span></div>
          <div :style="'color: '+GetColorMain()">
            {{ formatDate(data.verifyProTime,"yyyy/MM/dd hh:mm",true) }}
          </div>
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>审核意见</span></div>
          <div :style="'color: '+GetColorMain()">
            {{ data.verifyProAbout }}
          </div>
        </div>
      </template>
    </div>

    <div v-if="loading" class="fastRect">
      <div class="title">学员信息</div>
      <van-field
        v-model="data.customerInfo.loaclName"
        label="本地姓名"
        readonly
        placeholder="请输入本地姓名"
      />
      <van-field
        v-model="data.customerInfo.lastName"
        label="英文(拼音)姓"
        readonly
        placeholder="请输入英文(拼音)姓"
      />
      <van-field
        v-model="data.customerInfo.firstName"
        label="英文(拼音)名"
        placeholder="请输入英文(拼音)名"
        readonly
      />
      <van-field
        v-model="birthday"
        label="生日"
        placeholder="请选择出生日期"
        readonly
      />
      <van-field
        v-model="data.customerInfo.email"
        label="邮箱"
        placeholder="请输入电子邮箱"
        readonly
      />
      <van-field
        v-model="sex"
        label="性别"
        placeholder="请输入电子邮箱"
        readonly
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>照片</span></div>
        <div class="van-cell__value" style="text-align:left;">
          <van-image
            width="6rem"
            :src="data.customerInfo.headIcon"
          />
        </div>
      </div>
    </div>
    <div v-if="loading" class="fastRect">
      <div class="title">邮寄信息</div>
      <van-field
        v-model="data.customerInfo.country"
        required
        label="国家"
        readonly
      />
      <van-field
        v-if="data.customerInfo.country==='CHN'"
        v-model="data.customerInfo.zipString"
        required
        label="地区"
        readonly
      />
      <van-field
        v-if="data.customerInfo.country!=='CHN'"
        v-model="data.customerInfo.cityEng"
        required
        label="城市"
        readonly
      />
      <van-field
        v-model="data.customerInfo.address"
        required
        label="地址"
        readonly
      />
      <van-field
        v-model="data.customerInfo.postalCode"
        required
        label="邮编"
        readonly
      />
      <van-field
        v-model="data.customerInfo.phone"
        required
        label="手机号码"
        readonly
      />
    </div>
    <div class="downButton">
      <van-button v-if="loading && data.state==='WAIT'" type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" :loading="buttonLoading" @click="onNext">我已核对无误提交给教练</van-button>
      <van-button v-if="loading" plain type="default" :color="GetColorMain()" style="width:100%" @click="onBack">返回</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Popup, Dialog, Image } from 'vant'
import { GetServiceUrl } from '@/utils/request'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Image.name]: Image,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的待发放证书',
      backurl: '/my/index',
      loading: false,
      code: undefined,
      createTime: '',
      buttonLoading: false,
      data: {

      },
      sex: undefined,
      birthday: undefined,
      zip: undefined,
      state: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.code = this.$route.params.id
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    GetServiceUrl,
    onNext() {
      Dialog.confirm({
        title: '核对认证信息',
        message: '我已经仔细核对认证信息，并确认信息真实准确有效，一旦提交不能撤销!' +
            '\r\n英文(拼音)姓:' + this.data.customerInfo.lastName +
            '\r\n英文(拼音)名:' + this.data.customerInfo.firstName +
            '\r\n生日:' + this.birthday +
            '\r\n邮箱:' + this.data.customerInfo.email
      }).then(() => {
        this.onUploadCustomerInfo()
      })
    },
    onUploadCustomerInfo() {
      this.buttonLoading = true
      request({
        url: '/Pro/UserConfirmCustomerInfo',
        method: 'post',
        params: { code: this.code }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        this.init()
      })
    },
    onBack() {
      this.$router.push(this.backurl)
    },
    init() {
      request({
        url: '/Pro/getPicByCode',
        method: 'post',
        params: { code: this.code }
      }).then(Response => {
        this.loading = true
        if (!Response.success) {
          return
        }
        this.data = Response.data
        this.birthday = formatDate(this.data.customerInfo.birthday, 'yyyy/MM/dd')
        this.sex = GetEnumText('Em_wxSex', this.data.customerInfo.sex)
        this.createTime = formatDate(this.data.createTime, 'yyyy/MM/dd hh:mm', true)
        switch (this.data.state) {
          case 'WAITPAY':
            this.state = GetEnumText('Em_DivePicState', 'WAITCONFIRM')
            break
          case 'WAITPAYCONFIRM':
            this.state = GetEnumText('Em_DivePicState', 'WAITCONFIRM')
            break
          case 'ERROR':
            this.state = GetEnumText('Em_DivePicState', 'PROCESSING')
            break
          case 'MANUAL':
            this.state = GetEnumText('Em_DivePicState', 'PROCESSING')
            break
          default:
            this.state = GetEnumText('Em_DivePicState', this.data.state)
            break
        }
      })
    }
  }
}
</script>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.fastRect .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}
.downButton{
    margin: 1em;
}
.topRemark{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 2em;
    margin: 1em;
    font-size: 0.9em;
    text-align: center;
}
.cutIconRect{
    width: 100%;
    height: 20em !important;
}
.tools{
  position: absolute;
  right: 0.5em;
  top:0.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
  text-align: center;
  background-color: #fff;
}
.IconRect{
  overflow: hidden;
  position: relative;
}
.buttonChooseImg{
  width: 100%;
  color: #fff;
  border:none;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  height: 3em;
  line-height: 3em;
}
.photoAbout{
  font-size: 0.6em;
  color: #999;
}
.customerRect{
  padding: 0.5em 1em;
  border: 1px solid #ccc;
  margin-bottom: 0.5em;
}
</style>
